const polyfill = `<script>
if (!Object.hasOwn) {
    Object.defineProperty(Object, "hasOwn", {
        value: function (object, property) {
            if (object == null) {
                throw new TypeError('hasOwn called on Object null or undefined')
            }
            return Object.prototype.hasOwnProperty.call(object, property);
        },
        configurable: true,
        writable: true,
        enumerable: false,
    });
};
</script>`;

module.exports = {
    polyfill
};
